import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { isEmpty, pickBy } from 'lodash-es';

import { updateUserSettings } from './actions';
import initialEditorState from './initialEditorState'; // eslint-disable-line
import { AUTHORIZED_CONTENT_TYPE_FOMRS } from '../../constants';
import { setSelectedContentType } from '../../actions';
import useGetCurrentUserSettings from '../../../shared/hooks/useGetCurrentUserSettingsHook';
import notificationTypes from '../../../shared/components/formNotification/notificationTypes';
import FormNotification from '../../../shared/components/formNotification';
import Loader from '../../../shared/components/loader';
import { getValidationError } from '../../../helpers/dataOperations/form/validationMessageHelper';
import validate from './editorStateValidator';

const UserSettings = () => {
  const dispatch = useDispatch();
  const [editorState, setEditorState] = useState(initialEditorState);
  const [isDataSaving, setIsDataSaving] = useState(false);
  const [updatedEditorState, setUpdatedEditorState] = useState({});
  const [formMessage, setFormMessage] = useState();
  const { userSettings, isFetching, errorMessage } = useGetCurrentUserSettings(null);
  const [validationMessage, setValidationMessage] = useState(true);

  useEffect(() => {
    if (userSettings) {
      const noNilUserSettings = pickBy(userSettings, (param) => (!!param));
      setEditorState(noNilUserSettings);
    }
  }, [userSettings]);

  const returnButtonClick = () => {
    dispatch(setSelectedContentType(AUTHORIZED_CONTENT_TYPE_FOMRS));
  };

  const onConfirmationSuccess = () => {
    setFormMessage({ value: 'Dane użytkownika zostały zmienione.', type: notificationTypes.SUCCESS });
    setIsDataSaving(false);
  };

  const onConfirmationFailure = (message) => {
    setFormMessage(message);
    setIsDataSaving(false);
  };

  const confirmButtonClick = () => {
    if (!isEmpty(updatedEditorState)) {
      setIsDataSaving(true);
      const errors = validate(editorState);

      if (!errors) {
        setValidationMessage(null);
        updateUserSettings(editorState, onConfirmationSuccess, onConfirmationFailure);
      } else {
        setValidationMessage(errors);
        setIsDataSaving(false);
      }
    }
  };

  const onChange = (name) => (evt) => {
    setEditorState({ ...editorState, [name]: evt.target.value });
    setUpdatedEditorState({ ...updatedEditorState, [name]: evt.target.value });
  };

  return (
    <div className="user-settings">
      <div className="user-settings-logo-wrapper">
        <div className="title">
          Konfiguracja konta
        </div>
        <Choose>
          <When condition={errorMessage}>
            <FormNotification message={errorMessage} />
          </When>
          <When condition={isFetching}>
            <Loader />
          </When>
          <Otherwise>
            <div className="form">
              <div className="form-group">
                <div className="error-message">
                  {getValidationError(validationMessage, 'firstName')}
                </div>
                <label htmlFor="firstname">
                  <div className="required-label-field">
                    Imię
                  </div>
                  <input
                    className="form-control"
                    id="firstname"
                    type="text"
                    value={editorState.firstName || ''}
                    onChange={onChange('firstName')}
                  />
                </label>
              </div>
              <div className="form-group">
                <div className="error-message">
                  {getValidationError(validationMessage, 'lastName')}
                </div>
                <label htmlFor="lastName">
                  <div className="required-label-field">
                    Nazwisko
                  </div>
                  <input
                    className="form-control"
                    id="lastName"
                    type="text"
                    value={editorState.lastName || ''}
                    onChange={onChange('lastName')}
                  />
                </label>
              </div>
              <div className="form-group">
                <div className="error-message">
                  {getValidationError(validationMessage, 'phone')}
                </div>
                <label htmlFor="phone">
                  Telefon
                  <input
                    className="form-control"
                    id="phone"
                    type="text"
                    value={editorState.phone || ''}
                    onChange={onChange('phone')}
                  />
                </label>
              </div>
              <div className="form-group">
                <div className="error-message">
                  {getValidationError(validationMessage, 'mobilephone')}
                </div>
                <label htmlFor="mobilephone">
                  Telefon komórkowy
                  <input
                    className="form-control"
                    id="mobilephone"
                    type="text"
                    value={editorState.mobilePhone || ''}
                    onChange={onChange('mobilePhone')}
                  />
                </label>
              </div>
              <div className="form-group">
                <div className="error-message">
                  {getValidationError(validationMessage, 'currentPassword')}
                </div>
                <label htmlFor="currentPassword">
                  Obecne hasło
                  <input
                    className="form-control"
                    id="currentPassword"
                    type="password"
                    value={editorState.currentPassword || ''}
                    onChange={onChange('currentPassword')}
                  />
                </label>
              </div>
              <div className="form-group">
                <div className="error-message">
                  {getValidationError(validationMessage, 'password')}
                </div>
                <label htmlFor="password">
                  Nowe hasło
                  <input
                    className="form-control"
                    id="password"
                    type="password"
                    value={editorState.password || ''}
                    onChange={onChange('password')}
                  />
                </label>
              </div>
              <div className="form-group">
                <div className="error-message">
                  {getValidationError(validationMessage, 'repeatpassword')}
                </div>
                <label htmlFor="repeatpassword">
                  Powtórz nowe hasło
                  <input
                    className="form-control"
                    id="repeatpassword"
                    type="password"
                    value={editorState.repeatpassword || ''}
                    onChange={onChange('repeatpassword')}
                  />
                </label>
              </div>
              <FormNotification message={formMessage} />
            </div>
          </Otherwise>
        </Choose>
        <div className="actions">
          <Choose>
            <When condition={isDataSaving}>
              <div className="action-button spinner-wrapper">
                <div className="spinner-border text-light" role="status" />
              </div>
            </When>
            <Otherwise>
              <If condition={!errorMessage}>
                <div
                  className="button action-button"
                  onClick={confirmButtonClick}
                  role="button"
                  title="Zapisz"
                >
                  Zapisz
                </div>
              </If>
            </Otherwise>
          </Choose>
          <div
            className="button action-button float-right"
            onClick={returnButtonClick}
            role="button"
            title="Powrót"
          >
            Powrót
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSettings;
